import React from 'react';
import ScreenCapturePortal from '../../components/screen-capture/portal';
import styles from './loading.module.scss';
import { AppLoading } from '../../components/loading/';

const CreateProductLoading = () => (
  <ScreenCapturePortal>
    <div className={styles.createProductOverlay}>
      <div className={styles.breathingButton}>
        <AppLoading />
      </div>
    </div>
  </ScreenCapturePortal>
);

export default CreateProductLoading;
